  <template>
  <div class="input-container">
    <v-card flat class="cbg-white-container">
      <v-card-text>
        <div
          v-if="
            !showPharmacyProfile &&
            !showDiagnosticsProfile &&
            !showBloodBankProfile &&
            !showAmbulanceProfile
          "
        >
          <v-row>
            <v-col cols="12" md="2" sm="6">
              <label for class="fz-10px">Search by Name</label>
              <div class="search-div position-relative">
                <input
                  class="form-control"
                  placeholder="Name"
                  v-model="searchParameter.name"
                  @input="debounceSearch(true)"
                />
                <div
                  v-if="searchParameter.name !== ''"
                  class="search-svg position-absolute"
                  @click="clearSearch()"
                >
                  <crossSVG />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <div class="position-relative">
                <label for class="fz-12px">Select Role</label>
                <select
                  name
                  id
                  class="form-control"
                  @change="changeRole()"
                  v-model="role"
                >
                  <option value="all">All</option>
                  <option value="pharmacy">Pharmacy</option>
                  <option value="diagnostics-lab">Diagnostics Lab</option>
                  <option value="bloodbank">Blood Bank</option>
                  <option value="ambulance">Ambulance</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="datepicker pos-r">
              <label for class="d-block-mob fz-10px"
                >Date Range (Joined On)</label
              >
              <datepicker
                v-model="joinOnDateRange"
                @input="dateChange()"
                ref="datepicker"
                :model-config="datePickerConfig"
                :max-date="new Date()"
                is-range
                :masks="{ input: 'DD/MM/YYYY' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="
                      !!inputValue.start && !!inputValue.end
                        ? inputValue.start + ' - ' + inputValue.end
                        : 'DD/MM/YYYY'
                    "
                    v-on="inputEvents.start"
                    class="form-control position-relative"
                    placeholder="DD/MM/YYYY"
                  />
                  <div
                    v-if="!!inputValue.start && !!inputValue.end"
                    class="cross-svg"
                    @click="resetJoiningDate"
                  >
                    <crossSVG />
                  </div>
                </template>
              </datepicker>
              <div class="calendarsvg userinputcalendar pos-a">
                <calendarSVG />
              </div>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <div class="position-relative">
                <label for class="fz-12px">Profile</label>
                <select
                  name
                  id
                  class="form-control"
                  v-model="isCompleted"
                  @change="changeProfile()"
                >
                  <option value>All</option>
                  <option value="APPROVED">Approved</option>
                  <option value="PENDING">Pending</option>
                  <option value="REJECT">Rejected</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </v-col>
            <v-col
              v-if="permissions.includes('CAN_EXPORT_CSV_CENTER')"
              cols="12"
              md="3"
              sm="6"
            >
              <label class="col-sm-12 mb-0 d-none-mob1"></label>
              <v-btn @click="downloadCsv()" class="btn btn-primary"
                >Export</v-btn
              >
            </v-col>
          </v-row>

          <loader v-if="showLoader"></loader>

          <v-row>
            <v-col cols="12" class="mt-2">
              <div class="table-div overflow-auto">
                <table
                  class="table userlistTable table-width small-table-width"
                >
                  <thead>
                    <tr class="table-success">
                      <th scope="col">Centre Name</th>
                      <th scope="col">Center Contact No</th>
                      <th scope="col">Owner Contact No</th>
                      <th scope="col">Location</th>
                      <th scope="col" class="small-min-width-120">
                        Centre Type
                      </th>
                      <th scope="col">Joined On</th>
                      <th
                        scope="col"
                        v-if="role !== 'ambulance'"
                        class="min-width-120"
                      >
                        Home Delivery
                      </th>
                      <th
                        scope="col"
                        v-if="role === 'pharmacy' || role === 'all'"
                        class="min-width-120"
                      >
                        Is Generic
                      </th>
                      <!-- <th scope="col"> GST No.</th> -->
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Name"
                          placeholder="Name"
                          v-model="searchParameter.name"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Number"
                          placeholder="Center Number"
                          v-model="searchParameter.number"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td></td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Location"
                          placeholder="Location"
                          v-model="searchParameter.location"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td v-if="role === 'ambulance'"></td>
                      <td>
                        <div class="position-relative w-7 table-select">
                          <select
                            name
                            id
                            class="form-control"
                            @change="debounceSearch(true)"
                            v-model="searchParameter.type_of_center"
                          >
                            <option value>All</option>
                            <option value="Private">Private</option>
                            <option value="Paid">Paid</option>
                            <option value="Free">Free</option>
                            <option value="Charitable">Charitable</option>
                          </select>
                          <span class="drop-icon">
                            <i
                              aria-hidden="true"
                              class="
                                v-icon
                                mdi mdi-menu-down
                                theme--light
                                position-absolute
                              "
                            ></i>
                          </span>
                        </div>
                      </td>
                      <td></td>
                      <td v-if="role !== 'ambulance'">
                        <div class="position-relative w-7 table-select">
                          <select
                            name
                            id
                            class="form-control"
                            @change="debounceSearch(true)"
                            v-model="searchParameter.home_delivery"
                          >
                            <option value>All</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                          <span class="drop-icon">
                            <i
                              aria-hidden="true"
                              class="
                                v-icon
                                mdi mdi-menu-down
                                theme--light
                                position-absolute
                              "
                            ></i>
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="position-relative w-7 table-select">
                          <select
                            v-if="role === 'pharmacy' || role === 'all'"
                            name
                            id
                            class="form-control"
                            @change="debounceSearch(true)"
                            v-model="searchParameter.is_generic"
                          >
                            <option value>All</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                          <span class="drop-icon">
                            <i
                              aria-hidden="true"
                              class="
                                v-icon
                                mdi mdi-menu-down
                                theme--light
                                position-absolute
                              "
                            ></i>
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="(center, index) in centerList" :key="index">
                      <!-- Centre Name -->
                      <td>
                        <div>{{ center.general && center.general.name }}</div>
                      </td>
                      <!--Center Contact No -->
                      <td>
                        <div>{{ center && center.general.contact_number }}</div>
                      </td>
                      <!-- Owner Contact No -->
                      <td>
                        <div>{{ center && center.created_by.mobile }}</div>
                      </td>
                      <!-- Location -->
                      <td>
                        {{ (center &&
                          center.general.address &&
                          center.general.address.city) ? center.general.address.city : (center.general.address.state ? center.general.address.state :'-') }}
                      </td>

                      <!-- Centre Type -->
                      <td>
                        <div>{{ getTypeOfCenter(center) }}</div>
                      </td>
                      <!-- join on -->
                      <td>{{ center.created_at | formatDate }}</td>
                      <!-- Home Delivery -->
                      <td v-if="role !== 'ambulance'">
                        <div>{{ getHomeDelivery(center) }}</div>
                      </td>
                      <!-- Is Generic -->
                      <td v-if="role === 'pharmacy' || role === 'all'">
                        <div>
                          {{
                            center.pharmacy && center.pharmacy.is_generic_store
                              ? "Yes"
                              : "No"
                          }}
                        </div>
                      </td>
                      <!-- <td> {{center.general.gst_number ? center.general.gst_number : 'N/A'}} </td> -->
                      <!-- Action -->
                      <td class="action-div small-table-padding">
                        <div>
                          <CDropdown
                            color="link"
                            size="lg"
                            :caret="false"
                            class="dropdowndocbox"
                          >
                            <template #toggler-content>
                              <verticalDotsSVG />
                            </template>
                            <CDropdownItem @click="getViewDetails(center)"
                              >View Details</CDropdownItem
                            >
                            <CDropdownItem>Call</CDropdownItem>
                            <CDropdownItem>Chat</CDropdownItem>
                            <CDropdownItem @click="clickoutside()"
                              >Email</CDropdownItem
                            >
                            <CDropdownItem
                              v-if="
                                permissions.includes(
                                  'CAN_DOWNLOAD_QR_CODE_CENTER'
                                )
                              "
                              @click="downloadQr(center)"
                              id="qrcodebtn"
                              >Download QR code</CDropdownItem
                            >
                          </CDropdown>
                        </div>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                  <tbody v-if="isEmpty">
                    <tr>
                      <td colspan="8">
                        <h2 class="text-center">No Data Found</h2>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
          <div v-if="role === 'ambulance'">
            <p class="mb-0">
              Ambulance address count : {{ totalAmbulanceAddresses }}
            </p>
          </div>
          <pagination
            v-if="!isEmpty"
            class="mx-0 mob-t-center pagination-block"
            :recordPerPage="recordPerPage"
            :total="total"
            @changePage="changePage"
          />
          <div v-if="showPdf">
            <v-dialog v-model="showPdf" width="500" persistent id="view-box">
              <!-- <CModal
              :show.sync="showPdf"
              :no-close-on-backdrop="false"
              :close-on-esc="false"
              :centered="true"
              title="Profile QR"
              class="view-log-modal"
              id="view-box"
              >-->
              <pdf-html
                title="Profile QR"
                subject="shareLink"
                ref="pdfView"
                :identifier="centerId"
                :HideDownloadButton="true"
                :HidePrintButton="true"
                @close="showPdf = false"
                :buttons="[]"
                :queryParameters="urlQueryParam"
                :reCompile="true"
              ></pdf-html>
            </v-dialog>
            <!-- </CModal> -->
          </div>
        </div>

        <pharmacyProfileSummaryDetails
          v-if="showPharmacyProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></pharmacyProfileSummaryDetails>
        <diagnosticsLabProfileSummaryDetails
          v-if="showDiagnosticsProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></diagnosticsLabProfileSummaryDetails>
        <bloodBankProfileSummaryDetails
          v-if="showBloodBankProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></bloodBankProfileSummaryDetails>
        <ambulanceProfileSummaryDetails
          v-if="showAmbulanceProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></ambulanceProfileSummaryDetails>

        <image-preview
          @close="closeImageModal"
          v-if="openImageModal"
          :openImageModal="openImageModal"
          :source="fileUrl"
          :fileArcheType="fileArcheType"
        ></image-preview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import config from "@/config.js";
import formats from "@/formats";
import { pickSvg } from "@/views/SVG";
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
const imagePreview = () => import("@/components/modals/imagePreview.vue");
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
import debounce from "lodash/debounce";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { mapGetters } from "vuex";
import { bus } from "@/main.js";
// const centerApprovalModal = () =>
//   import("@/components/ApprovalCenters/centerApprovalModal.vue");

// const centerLogModal = () =>
//   import("@/components/ApprovalCenters/centerLogModal.vue");

const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  components: {
    pharmacyProfileSummaryDetails: () =>
      import("@/views/dashboardNew/userListing/pharmacyProfileSummaryDetails"),
    diagnosticsLabProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/diagnosticsLabProfileSummaryDetails"
      ),
    bloodBankProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/bloodBankProfileSummaryDetails.vue"
      ),
    ambulanceProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/ambulanceProfileSummaryDetails.vue"
      ),
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG", "crossSVG"),
    // "center-log-modal": centerLogModal,
    // "center-approval-modal": centerApprovalModal,
    "image-preview": imagePreview,
    pagination,
    InfoIconSVG,
    loader,
    Datepicker,
    PdfHtml: () => import("@/components/PdfHtml"),
  },
  data() {
    return {
      // shouldShowModal: false,
      totalAmbulanceAddresses: 0,
      showPdf: false,
      dayJS,
      formats,
      recordPerPage: 10,
      currentPage: 1,
      search: "",
      status: "ALL",
      // gstNumber: "345678956",
      centerList: [],
      role: "all",
      total: "",
      perPageOptions: [
        { perPage: 10, value: 10 },
        { perPage: 20, value: 20 },
        { perPage: 30, value: 30 },
        { perPage: 50, value: 50 },
        { perPage: 100, value: 100 },
      ],
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      statusOptions: [
        { name: "All", value: "ALL" },
        { name: "Pending", value: "PENDING" },
        { name: "Approved", value: "APPROVED" },
        { name: "Rejected", value: "REJECT" },
        { name: "Not Uploaded", value: "NOT_UPLOADED" },
      ],
      showLoader: false,
      isEmpty: false,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      centerData: {},
      showCenterApprovalModal: false,
      statusType: "",
      showCenterLogModal: false,
      joinOnDateRange: { start: "", end: "" },
      isCompleted: "",
      showPharmacyProfile: false,
      showDiagnosticsProfile: false,
      showBloodBankProfile: false,
      showAmbulanceProfile: false,
      centerDetails :{},
      searchParameter: {
        name: "",
        number: "",
        location: "",
        type_of_center: "",
        home_delivery: "",
        is_generic: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  mounted() {
    this.debounceSearch();
    this.centerDetails = this.$route.params;
    if (this.centerDetails && this.centerDetails.role){
      this.role =this.centerDetails.role ? this.centerDetails.role : this.role
      this.searchParameter.number= this.centerDetails.user.mobile ? this.centerDetails.user.mobile : this.searchParameter.number
    }
  },

  filters: {
    formatDate: (date) => {
      return dayJS(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    // showPopup() {
    //   this.shouldShowModal = true;
    // },
    // hidePopup() {
    //   this.shouldShowModal = false;
    // },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.debounceSearch(true);
    },
    closeProfile() {
      this.showPharmacyProfile = false;
      this.showDiagnosticsProfile = false;
      this.showBloodBankProfile = false;
      this.showAmbulanceProfile = false;
    },
    getViewDetails(centerData) {
      switch (centerData.role) {
        case "pharmacy":
          this.showPharmacyProfile = true;
          this.userId = centerData._id;
          break;

        case "diagnostics-lab":
          this.showDiagnosticsProfile = true;
          this.userId = centerData._id;
          break;
        case "bloodbank":
          this.showBloodBankProfile = true;
          this.userId = centerData._id;
          break;
        case "ambulance":
          this.showAmbulanceProfile = true;
          this.userId = centerData._id;
          break;

        default:
          this.showPharmacyProfile = false;
          this.showDiagnosticsProfile = false;
          this.showBloodBankProfile = false;
          this.showAmbulanceProfile = false;
          this.userId = "";
      }
    },

    getTypeOfCenter(centerData) {
      if (
        centerData &&
        centerData.pharmacy &&
        centerData.pharmacy.type_of_pharmacy
      ) {
        return centerData.pharmacy.type_of_pharmacy;
      } else if (
        centerData &&
        centerData["diagnostics-lab"] &&
        centerData["diagnostics-lab"].type_of_diagnostic
      ) {
        return centerData["diagnostics-lab"].type_of_diagnostic;
      } else if (
        centerData &&
        centerData.bloodbank &&
        centerData.bloodbank.type_of_bloodbank
      ) {
        return centerData.bloodbank.type_of_bloodbank;
      } else if (
        centerData &&
        centerData.ambulance &&
        centerData.ambulance.ambulance_type
      ) {
        return centerData.ambulance.ambulance_type;
      } else {
        return `―`;
      }
    },
    clearSearch() {
      this.searchParameter.name = "";
      this.debounceSearch(true);
    },
    getHomeDelivery(centerData) {
      if (
        centerData &&
        centerData.pharmacy &&
        centerData.pharmacy.is_available_for_home_services
      ) {
        return "Yes";
      } else if (
        centerData &&
        centerData["diagnostics-lab"] &&
        centerData["diagnostics-lab"].is_available_for_home_services
      ) {
        return "Yes";
      } else if (
        centerData &&
        centerData.bloodbank &&
        centerData.bloodbank.is_available_for_home_services
      ) {
        return "Yes";
      } else {
        return `No`;
      }
    },
    changeProfile() {
      this.debounceSearch(true);
    },
    changeRole() {
      this.debounceSearch(true);
      this.showPdf = false;
    },
    dateChange() {
      this.debounceSearch(true);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.debounceSearch();
    },
    openViewDetails(history) {
      this.openImageModal = true;
      this.closeModal();
      this.fileUrl = history.registration_proof_image_url;
      this.fileArcheType = "Certificate";
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    verifyCenter(type, centerData) {
      this.centerData = centerData;
      this.showCenterApprovalModal = true;
      this.statusType = type;
    },
    openCenterLogModal(centerData) {
      this.centerData = centerData;
      this.showCenterLogModal = true;
    },
    closeModal() {
      this.showCenterLogModal = false;
      this.showCenterApprovalModal = false;
    },
    getCenterList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        center_name: this.searchParameter.name,
        is_complete: this.isCompleted,
        joined_on_from:
          this.joinOnDateRange.start === ""
            ? ""
            : new Date(this.joinOnDateRange.start).toISOString(),
        joined_on_to:
          this.joinOnDateRange.end === ""
            ? ""
            : new Date(this.joinOnDateRange.end).toISOString(),
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
        type_of_center: this.searchParameter.type_of_center,
        is_available_for_home_devliery: this.searchParameter.home_delivery,
        is_generic: this.searchParameter.is_generic,
      };

      // params.center_name === ""
      //   ? delete params.center_name
      //   : params.center_name;

      let url = `${config.BASE_URL}api/v2/admin/center-list/${this.role}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.totalAmbulanceAddresses =
              response.body.data.total_ambulance_addresses;
            this.centerList = response.body.data.list;
            this.centerList.map((el) => {
              Object.keys(el).map((element) => {
                switch (element) {
                  case "pharmacy":
                    return (el.role = element);
                    break;
                  case "diagnostics-lab":
                    return (el.role = element);
                    break;
                  case "bloodbank":
                    return (el.role = element);
                    break;
                  case "ambulance":
                    return (el.role = element);
                    break;
                }
              });
            });

            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.centerList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        center_name: this.searchParameter.name,
        is_complete: this.isCompleted,
        joined_on_from:
          this.joinOnDateRange.start === ""
            ? ""
            : new Date(this.joinOnDateRange.start).toISOString(),
        joined_on_to:
          this.joinOnDateRange.end === ""
            ? ""
            : new Date(this.joinOnDateRange.end).toISOString(),
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
        type_of_center: this.searchParameter.type_of_center,
        is_available_for_home_devliery: this.searchParameter.home_delivery,
        is_generic: this.searchParameter.is_generic,
      };
      let url = `${config.BASE_URL}api/v2/admin/center-list-csv/${this.role}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    checkRequestWasRejected(histories) {
      let truth = false;
      histories.forEach((history) => {
        if (history.current_document_status == "REJECT") {
          truth = true;
        }
      });
      return truth;
    },
    downloadQr(center) {
      let baseUrl = "";
      switch (center.center_type) {
        case "pharmacy":
          baseUrl = config.PHARMACY_URL;
          break;
        case "diagnostics-lab":
          baseUrl = config.DIAGNOSTICS_URL;
          break;
        case "ambulance":
          baseUrl = config.AMBULANCE_URL;
          break;
        case "bloodbank":
          baseUrl = config.BLOODBANK_URL;
          break;
      }
      this.$http
        .get(`${baseUrl}api/v1/centers/${center._id}/profile`)
        .then((response) => {
          response = response.data;
          if (response.status) {
            response = response.data;
            let centerType = "";
            if (center.center_type === "diagnostics-lab") {
              centerType = "diagnostic";
            } else {
              centerType = center.center_type;
            }
            this.urlQueryParam = `role=${centerType}&slug=${response.slug}&profileName=${center.general.name}&centerProfile=true`;
            this.centerId = center._id;
            this.showPdf = true;
          }
        });
    },
    debounceSearch: debounce(function (pageReset = false) {
      if (pageReset) {
        bus.$emit("PAGE_CHANGE");
        this.currentPage = 1;
      }

      this.getCenterList();
    }, 500),
  },
};
</script>